import { EmptyState } from "@/ui";
import { useT } from "@/app";

/**
 * The cloud-only degradation state. patient-portal is a central-hosted module (D-22); on a local
 * install its /api/v1 routes are simply not mounted, so a probe 404s. Rather than surfacing a scary
 * error, every screen renders this calm "indisponible sur cette installation" panel — no action is
 * required of the operator. Distinct from a data 404 (e.g. "no report emitted yet").
 */
export function ModuleAbsentState() {
  const { t } = useT();
  return <EmptyState glyph="☁" title={t("pp.absent.title")} description={t("pp.absent.desc")} />;
}
